export const typeOfResetPasswordWithTokenDialog = 'typeOfResetPasswordWithTokenDialog';
export const resetPasswordWithTokenDialogSetResponseStatusReducerType = 'resetPasswordWithTokenDialogSetResponseStatusReducerType';
export const resetPasswordWithTokenDialogSetNewPasswordReducerType = 'resetPasswordWithTokenDialogSetNewPasswordReducerType';
export const resetPasswordWithTokenDialogSetConfirmationPasswordReducerType =
  'resetPasswordWithTokenDialogSetConfirmationPasswordReducerType';
export const resetPasswordWithTokenDialogReducerKey = 'resetPasswordWithTokenDialogReducerKey';

export const RESPONSE_STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};
